import React from 'react';
import './index.scss';
import {
  formatTextFloat,
  formatPercent,
  formatPrice,
  formatChange,
} from '../../../helpers/Text';
import TextBlinkCustom from '../../../common/text-blink-custom';
import {
  getColorPrice,
  getIconPriceFollowReferencePrice,
} from './../../../helpers/Color';

function renderContent(
  MatchPrice,
  PriceChange,
  PercentPriceChange,
  ReferencePrice,
  CeilingPrice,
  FloorPrice,
) {
  const matchPrice = !isNaN(MatchPrice / 1000)
    ? (MatchPrice / 1000)
        .toFixed(2)
        .toString()
        .split('.')
    : ['--', '--'];

  const classNameColor = getColorPrice(
    MatchPrice,
    ReferencePrice,
    CeilingPrice,
    FloorPrice,
  );

  const classNameIcon = getIconPriceFollowReferencePrice(
    MatchPrice,
    ReferencePrice,
  );

  return (
    <div className={`summary-info-wrapper justify-content-start`}>
      <div className="left-container">
        <div className={`main-price ${classNameColor}`}>
          {formatTextFloat(parseFloat(`${matchPrice[0]}`), 0)}
        </div>
        <div className="d-flex flex-column justify-content-center">
          <div className={`sub-price ${classNameColor}`}>
            {`.${matchPrice[1] || '00'}`}
          </div>
          <div className="currency">VND</div>
        </div>
      </div>
      <div className="right-container d-flex flex-column">
        <div className={`sub-price ${classNameColor}`}>
          {`${formatChange(formatTextFloat(formatPrice(PriceChange)))}`}
        </div>
        <div className="percent d-flex">
          <i className={`${classNameColor} ${classNameIcon} fs-10 mr-1`} />
          {`${formatTextFloat(formatPercent(PercentPriceChange))}%`}
        </div>
      </div>
    </div>
  );
}

class indexSummary extends React.Component {
  render() {
    const {
      topContent: {
        MatchPrice,
        PriceChange,
        PercentPriceChange,
        ReferencePrice,
        CeilingPrice,
        FloorPrice,
      },
      keyToCompare,
    } = this.props;

    const priceContent =
      parseFloat(MatchPrice) > 0
        ? renderContent(
            MatchPrice,
            PriceChange,
            PercentPriceChange,
            ReferencePrice,
            CeilingPrice,
            FloorPrice,
          )
        : renderContent('--', '--', '--', '--', '--', '--');

    return (
      <TextBlinkCustom data={this.props.data} compareKey={keyToCompare}>
        {priceContent}
      </TextBlinkCustom>
    );
  }
}

indexSummary.defaultProps = {
  topContent: {
    MatchPrice: 0,
    PriceChange: 0,
    PercentPriceChange: 0,
    ReferencePrice: 0,
    FloorPrice: null,
    CeilingPrice: null,
  },
  keyToCompare: 'tradingDate',
};

export default indexSummary;
